<template>
  <div id="contenedor-actividades-vencidas-listado">
    <div style="width: 350px" class="mr-2">
      <custom-text-field
      label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <v-simple-table>
      <template
        v-slot:default>
        <thead>
          <tr>
            <th width="200">Contrato</th>
            <th>Pendiente</th>
            <th width="120">Fecha Plazo</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="actividad in getListado">
            <template>
              <tr
                :key="actividad.id">
                <td class="font-weight-bold">
                  {{ actividad.contrato.numero }}
                </td>
                <td>
                  <cortar-texto
                    :texto="actividad.descripcion"
                    :cantidad-caracteres="75">
                  </cortar-texto>
                </td>
                <td>
                  {{new Date(`${actividad.fechaPlazo} 00:00:0`).toLocaleDateString()}}
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>

import CortarTexto from '@/components/CortarTextos.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ActividadesVencidasListado',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    CortarTexto,
    CustomTextField,
  },
  data() {
    return {
      debounce: null,
      buscarTexto: '',
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
  },
  computed: {
    getListado() {
      if (!this.listado) return [];
      return this.listado
        .slice()
        .sort((a, b) => a.fechaPlazo - b.fechaPlazo)
        .filter((actividad) => {
          if (!this.buscarTexto) return actividad;
          const expt = new RegExp(this.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(actividad.contrato.numero);
          const descripcion = this.$normalizacionTexto(actividad.descripcion);
          return (
            expt.test(numero)
            || expt.test(descripcion)
            || expt.test(actividad.contrato.numero)
            || expt.test(actividad.descripcion)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
